export default "__VITE_ASSET__4d1a1811__"